<template>
  <section class="flex flex-col">
    <div class="bg-lime-green text-white">
      <div class="container-lg py-[44px] flex flex-col gap-[16px]">
        <h1 class="m-0 text-[2rem] md:text-[2.75rem] leading-[32px] font-medium whitespace-break-spaces">
          {{ in18["hello_label"] }} {{ user.full_name }}
        </h1>
        <span class="text-[14px] md:text-[16px] leading-[24px]">
          {{ in18["order_description"] }}
        </span>
      </div>
    </div>
    <div class="container-lg py-[56px]">
      <div class="tabs">
        <div class="flex border-b border-light-gray/25">
          <button
            class="w-1/2 flex items-center justify-center pb-[15px] text-[16px] leading-[20px] font-medium uppercase border-b-[2px]"
            :class="[
              activeTab === 'orders'
                ? 'text-lime-green  border-lime-green'
                : 'text-[#B0B0B0] border-white/0',
            ]"
            @click="activeTab = 'orders'"
          >
            <svg
              class="inline"
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="21"
              viewBox="0 0 17 21"
              fill="none"
            >
              <path
                :class="[activeTab === 'orders' ? 'fill-lime-green' : 'fill-[#B0B0B0]']"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.0157 1.35164C0.332031 2.0353 0.332031 3.1343 0.332031 5.33464V15.8346C0.332031 18.035 0.332031 19.134 1.0157 19.8176C1.69936 20.5013 2.79836 20.5013 4.9987 20.5013H11.9987C14.199 20.5013 15.298 20.5013 15.9817 19.8176C16.6654 19.134 16.6654 18.035 16.6654 15.8346V5.33464C16.6654 3.1343 16.6654 2.0353 15.9817 1.35164C15.298 0.667969 14.199 0.667969 11.9987 0.667969H4.9987C2.79836 0.667969 1.69936 0.667969 1.0157 1.35164ZM4.9987 5.33464C4.68928 5.33464 4.39253 5.45755 4.17374 5.67635C3.95495 5.89514 3.83203 6.19188 3.83203 6.5013C3.83203 6.81072 3.95495 7.10747 4.17374 7.32626C4.39253 7.54505 4.68928 7.66797 4.9987 7.66797H11.9987C12.3081 7.66797 12.6049 7.54505 12.8237 7.32626C13.0424 7.10747 13.1654 6.81072 13.1654 6.5013C13.1654 6.19188 13.0424 5.89514 12.8237 5.67635C12.6049 5.45755 12.3081 5.33464 11.9987 5.33464H4.9987ZM4.9987 10.0013C4.68928 10.0013 4.39253 10.1242 4.17374 10.343C3.95495 10.5618 3.83203 10.8586 3.83203 11.168C3.83203 11.4774 3.95495 11.7741 4.17374 11.9929C4.39253 12.2117 4.68928 12.3346 4.9987 12.3346H11.9987C12.3081 12.3346 12.6049 12.2117 12.8237 11.9929C13.0424 11.7741 13.1654 11.4774 13.1654 11.168C13.1654 10.8586 13.0424 10.5618 12.8237 10.343C12.6049 10.1242 12.3081 10.0013 11.9987 10.0013H4.9987ZM4.9987 14.668C4.68928 14.668 4.39253 14.7909 4.17374 15.0097C3.95495 15.2285 3.83203 15.5252 3.83203 15.8346C3.83203 16.1441 3.95495 16.4408 4.17374 16.6596C4.39253 16.8784 4.68928 17.0013 4.9987 17.0013H9.66536C9.97478 17.0013 10.2715 16.8784 10.4903 16.6596C10.7091 16.4408 10.832 16.1441 10.832 15.8346C10.832 15.5252 10.7091 15.2285 10.4903 15.0097C10.2715 14.7909 9.97478 14.668 9.66536 14.668H4.9987Z"
              />
            </svg>
            <span class="hidden md:block ml-[16px]">{{ in18["order_title"] }}</span>
          </button>
          <button
            class="w-1/2 flex items-center justify-center pb-[15px] text-[16px] leading-[20px] font-medium uppercase border-b-[2px]"
            :class="[
              activeTab === 'profile'
                ? 'text-lime-green  border-lime-green'
                : 'text-[#B0B0B0] border-white/0',
            ]"
            @click="activeTab = 'profile'"
          >
            <svg
              class="inline"
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="20"
              viewBox="0 0 25 20"
              fill="none"
            >
              <path
                :class="[activeTab === 'profile' ? 'fill-lime-green' : 'fill-[#B0B0B0]']"
                d="M11.332 6.5013C11.332 8.43797 9.7687 10.0013 7.83203 10.0013C5.89536 10.0013 4.33203 8.43797 4.33203 6.5013C4.33203 4.56464 5.89536 3.0013 7.83203 3.0013C9.7687 3.0013 11.332 4.56464 11.332 6.5013ZM14.832 19.3346H0.832031V17.0013C0.832031 14.423 3.97036 12.3346 7.83203 12.3346C11.6937 12.3346 14.832 14.423 14.832 17.0013M24.1654 10.0013V12.3346H13.6654V10.0013M24.1654 5.33464V7.66797H13.6654V5.33464M24.1654 0.667969V3.0013H13.6654V0.667969H24.1654Z"
                fill="#606060"
              />
            </svg>
            <span class="hidden md:block ml-[16px]">{{
              in18["page_edit_profile_data"]
            }}</span>
          </button>
        </div>
        <div class="mt-[32px]">
          <template v-if="activeTab === 'orders'">
            <profile-order-list :in18="in18" :user="user" />
          </template>
          <template v-else>
            <profile-details
              :captcha_site_key="captcha_site_key"
              :in18="in18"
              :user="user"
            />
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import ProfileOrderList from "../components/profile/ProfileOrderList.vue";
import ProfileDetails from "../components/profile/ProfileDetails.vue";

defineProps({
  in18: Object,
  captcha_site_key: String,
});

const user = ref({});
const activeTab = ref("orders");

onMounted(async () => {
  const userResponse = await axios.get("/api/user");
  user.value = userResponse.data.user;
});
</script>
